import { Redirect } from 'expo-router';

// Fallback for non-iOS platforms - redirect to main app
// iOS uses onboarding.ios.jsx with the full onboarding experience
export default function OnboardingFallback() {
  return <Redirect href="/" />;
}
